/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsHoopProduct
 */
export interface MelcoModelsHoopProduct {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoopProduct
     */
    product_code?: string | null;
}

export function MelcoModelsHoopProductFromJSON(json: any): MelcoModelsHoopProduct {
    return MelcoModelsHoopProductFromJSONTyped(json, false);
}

export function MelcoModelsHoopProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsHoopProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
    };
}

export function MelcoModelsHoopProductToJSON(value?: MelcoModelsHoopProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_code': value.product_code,
    };
}


